// export default function Wallet() {
//   return (
//     <div className='allpostdetails ud-wallet'>
//       <div className="user-details-card">

//         <div className="ud-header">
//           <div className="ud-title-wrap">
//             <span className="ud-icon-badge">
//               {/* <i className="bi bi-wallet2"></i> */}
//               <i class="bi bi-cash-stack"></i>
//               </span>
//             <h4>WALLET</h4>

//           </div>

//           <button className="ud-badge">
//             <i className="bi bi-plus-circle"></i> Add Coins
//           </button>
//         </div>

//         <hr />

//         {/* Body */}
//         <div className="ud-body">

//           <div className="coinscollected">
//             <h1 className="coinstop">100</h1>
//             <h3>Balance</h3>
//           </div>


//           {/* Stats */}
//           <div className="stats">
//             <div>
//               <h3 className="coinstoph3">100</h3>
//               <span>Collected* </span>
//             </div>
//             <div>
//               <h3 className="coinstoph3">1</h3>
//               <span>Gifted*</span>
//             </div>
//             <div>
//               <h3 className="coinstoph3">0</h3>
//               <span>Purchased*</span>
//             </div>
//           </div>

//           <div>
//             <h6>*lifetime</h6>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState , useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import CustomButton from "./CustomButton";
import { getUserById, adminAddCoins } from "../services/reactapis"; 
export default function Wallet() {
  const [showModal, setShowModal] = useState(false);
  const [coinsToAdd, setCoinsToAdd] = useState("");
  const [adding, setAdding] = useState(false);


  const { id } = useParams();
const [balance, setBalance] = useState(0);

const loadBalance = async () => {
  try {
    const token = localStorage.getItem("adminToken");
    const res = await getUserById(token, id);
    if (res?.success) setBalance(res.data.coins || 0);
  } catch (error) {
    console.error("Load balance error:", error?.response?.data || error);
  }
};

useEffect(() => {
  loadBalance();
}, [id]);

  const closeModal = () => {
    setShowModal(false);
    setCoinsToAdd("");
  };

const handleAddCoins = async () => {
  const coins = Number(coinsToAdd);

  if (!Number.isInteger(coins) || coins <= 0) {
    alert("Please enter valid coins (whole number)");
    return;
  }

  try {
    setAdding(true);
    const token = localStorage.getItem("adminToken");

    const res = await adminAddCoins(token, id, coins);

    if (res?.success) {
      setBalance(res.data.coins);   // UI-la udane update
      alert(res.message);
      closeModal();
    }
  } catch (error) {
    console.error("Add coins error:", error?.response?.data || error);
    alert(error?.response?.data?.message || "Failed to add coins");
  } finally {
    setAdding(false);
  }
};

  return (
    <div className="allpostdetails ud-wallet">
      <div className="user-details-card">

        <div className="ud-header">
          <div className="ud-title-wrap">
            <span className="ud-icon-badge">
              <i className="bi bi-cash-stack"></i>
            </span>
            <h4>WALLET</h4>
          </div>

          <CustomButton
            className="ud-badge"
            variant="#e2f0ef"
            onClick={() => setShowModal(true)}
          >
            <i className="bi bi-plus-circle"></i> Add Coins
          </CustomButton>
        </div>

        <hr />

        {/* Body */}
        <div className="ud-body">
          <div className="coinscollected">
            <h1 className="coinstop">{balance}</h1>
            <h3>Balance</h3>
          </div>

          <div className="stats">
            <div>
              <h3 className="coinstoph3">100</h3>
              <span>Collected*</span>
            </div>
            <div>
              <h3 className="coinstoph3">1</h3>
              <span>Gifted*</span>
            </div>
            <div>
              <h3 className="coinstoph3">0</h3>
              <span>Purchased*</span>
            </div>
          </div>

          <div>
            <h6>*lifetime</h6>
          </div>
        </div>
      </div>

      {/* Add Coins Modal */}
      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="hashtag-add-modal"
      >
        <Modal.Header className="hashtag-modal-header">
          <Modal.Title>Add Coins</Modal.Title>

          <CustomButton
            type="button"
            className="hashtag-close-btn"
            onClick={closeModal}
          >
            ×
          </CustomButton>
        </Modal.Header>

        <Modal.Body className="hashtag-modal-body">
          <Form.Group>
            <Form.Label className="profile-pill">Coins</Form.Label>
            <Form.Control
              type="number"
              min="1"
              placeholder="Enter coins"
              value={coinsToAdd}
              onChange={(e) => setCoinsToAdd(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="hashtag-modal-footer">
          <CustomButton
            className="hashtag-close-footer-btn"
            variant="secondary"
            onClick={closeModal}
          >
            Close
          </CustomButton>
          <CustomButton
            className="hashtag-save-btn"
            variant="primary"
            onClick={handleAddCoins}
            disabled={adding}
          >
            {adding ? "Adding..." : "Save"}
          </CustomButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
